import './Loader.css';

export type LoaderProps = {
  height: { type: 'exact'; value: number } | { type: 'fill' };
  accentColorOverride?: string;
  style?: React.CSSProperties;
};

export function Loader({ height, accentColorOverride, style }: LoaderProps) {
  const accentColor =
    accentColorOverride !== undefined && accentColorOverride.length > 0
      ? accentColorOverride
      : '#004BB3';
  const fillAccentColor = accentColor + '99';
  const passAccentColor = accentColor + '66';

  const heightStyleValue = (() => {
    if (height.type === 'exact') {
      return height.value;
    }

    return '100%';
  })();

  const cssVariableSubstitutions = {
    '--loader-background-a': fillAccentColor,
    '--loader-background-b': passAccentColor,
  } as React.CSSProperties;

  return (
    <div
      className="loader"
      style={{
        ...style,
        ...cssVariableSubstitutions,
        height: heightStyleValue,
      }}
    ></div>
  );
}
